import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchWatchlistRequest, setActiveTab } from '../../store/reducers/watchlistReducer';
import { getAvailableTabs } from '../custom';

const WatchListTabs = () => {
    const dispatch = useDispatch();

    const { activeTab } = useSelector(state => state.watchlist);

    const availableTabs = useMemo(() => getAvailableTabs(), []);

    useEffect(() => {
        if (availableTabs.length) {
            const savedTab = localStorage.getItem('watchlistActiveTab');
            const tabToActivate = availableTabs.includes(savedTab)
                ? savedTab
                : availableTabs[0];
            dispatch(setActiveTab(tabToActivate));
            dispatch(fetchWatchlistRequest());
        }
    }, [availableTabs, dispatch]);

    const handleTabChange = (tab) => {
        if (activeTab === tab) return;
        localStorage.setItem('watchlistActiveTab', tab);
        dispatch(setActiveTab(tab));
        dispatch(fetchWatchlistRequest());
    };

    return (
        <div className="flex space-x-2 mb-2">
            {availableTabs.map((tab) => (
                <button
                    key={tab}
                    className={`py-0 px-4 text-sm font-lato font-semibold ${activeTab === tab
                        ? 'border-b-[2px] border-blue-500 text-blue-500'
                        : 'hover:text-blue-500'
                        }`}
                    onClick={() => handleTabChange(tab)}
                >
                    {tab}
                </button>
            ))}
        </div>
    );
};

export default WatchListTabs;